import { FC, useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';
import {
  IBKJSideModalProps,
  BKJSideModalHeaderComponentType,
} from 'components/BKJSideModal/BKJSideModal.types';
import {
  WebBKJSideModalDrawer,
  BKJSideModalHeadingWrapper,
  BKJSideModalDrawerContent,
  BKJSideModalBackButton,
  BKJSideModalCloseButton,
} from 'components/BKJSideModal/BKJSideModal.styled';
import { isReactComponent, isReactElement, isString } from 'types/common.types';
import { BKJIcon } from '@bookjane2/bookjane-design-library';
import { QuerySwitch } from 'components/QuerySwitch';
import { Flex } from 'components/Flex';
import { useTranslation } from 'hooks/useTranslation';

export const WebBKJSideModalDrawerContainer: FC<IBKJSideModalProps> = (props) => {
  const {
    isOpen,
    onClose,
    showBackButton,
    onBack,
    children,
    headerComponent,
    bgColor,
    context,
    hasPadding = false,
    hasTabs = false,
    errorComponent,
    ...rest
  } = props;

  const HeaderComponent = headerComponent as BKJSideModalHeaderComponentType;
  const { t } = useTranslation();
  const titleId = useMemo(() => uuidv4(), []);
  return (
    <WebBKJSideModalDrawer
      role="dialog"
      aria-modal="true"
      aria-labelledby={titleId}
      {...rest}
      key="MobileBKJSideModalDrawer"
      initial={{ x: 556 }}
      animate={{ x: 0 }}
      exit={{ x: 556 }}
      transition={{
        type: 'tween',
        ease: 'easeOut',
        duration: 0.3,
      }}
    >
      <BKJSideModalHeadingWrapper $hasTabs={hasTabs}>
        {showBackButton && (
          <BKJSideModalBackButton type="button" onClick={onBack} aria-label={t('auth:BACK')}>
            <BKJIcon iconName="ChevronLeft" color="TextDarkGrey" />
            &nbsp;{t('auth:BACK')}
          </BKJSideModalBackButton>
        )}
        <Flex
          id={titleId}
          width="100%"
          height="100%"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          padding="0 118px"
          data-cy="hdr-new-custom-modal"
        >
          {isString(HeaderComponent) && HeaderComponent}
          {isReactComponent(HeaderComponent) && <HeaderComponent closeModal={onClose} />}
          {isReactElement(HeaderComponent) && HeaderComponent}
        </Flex>
        <BKJSideModalCloseButton type="button" onClick={onClose} aria-label={t('common:CLOSE')}>
          <BKJIcon data-cy="btn-close-customfield" iconName="CloseBold" color="TextDarkGrey" />
        </BKJSideModalCloseButton>
      </BKJSideModalHeadingWrapper>
      <BKJSideModalDrawerContent bgColor={bgColor} hasPadding={hasPadding}>
        {!!context ? (
          <QuerySwitch context={context} component={children} errorComponent={errorComponent} />
        ) : (
          children
        )}
      </BKJSideModalDrawerContent>
    </WebBKJSideModalDrawer>
  );
};
